import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css'; // optional

const Tooltip = ({content, children}) => {
  return <Tippy content={content}>{children}</Tippy>
}

export default Tooltip;